/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Feat2_TitleInputs */

const es_l7_feat2_title = /** @type {(inputs: L7_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspección técnica`)
};

const gl_l7_feat2_title = /** @type {(inputs: L7_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspección técnica`)
};

const en_l7_feat2_title = /** @type {(inputs: L7_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical inspection`)
};

/**
* | output |
* | --- |
* | "Technical inspection" |
*
* @param {L7_Feat2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_feat2_title = /** @type {((inputs?: L7_Feat2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Feat2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_feat2_title(inputs)
	if (locale === "en") return en_l7_feat2_title(inputs)
	return es_l7_feat2_title(inputs)
});